var map = {
	"./about1.svg": "ff47",
	"./about2.svg": "a66f",
	"./align-center.svg": "b9fd",
	"./align-left.svg": "b9cc",
	"./align-right.svg": "f918",
	"./arrow-right-custom.svg": "4684",
	"./awards1.svg": "5e84",
	"./awards2.svg": "0016",
	"./awards3.svg": "0e71",
	"./awards4.svg": "7c1a",
	"./awards5.svg": "99e0",
	"./awards6.svg": "3b37",
	"./awards7.svg": "5e8f",
	"./awards8.svg": "6648",
	"./awards9.svg": "796f",
	"./bottom.svg": "2a53",
	"./center.svg": "6f5e",
	"./classroom1.svg": "2e56",
	"./classroom2.svg": "e712",
	"./docUpload.svg": "69db",
	"./goals1.svg": "e7d6",
	"./goals2.svg": "c2f5",
	"./login/facebook.svg": "4631",
	"./login/github.svg": "7b1e",
	"./login/google.svg": "74c7",
	"./login/twitter.svg": "ceb3",
	"./mp4.svg": "88ff",
	"./team/getBoarded.svg": "f7e1",
	"./text.svg": "51ea",
	"./top.svg": "4725",
	"./url.svg": "e884",
	"./videowikiClass/aperture.svg": "c5c8",
	"./videowikiClass/check-square.svg": "0d55",
	"./videowikiClass/classroom-header.svg": "a751",
	"./videowikiClass/edit.svg": "39ff",
	"./videowikiClass/eye.svg": "05e3",
	"./videowikiClass/group-chat.svg": "fb0e",
	"./videowikiClass/mic.svg": "7cc2",
	"./videowikiClass/monitor.svg": "195c",
	"./videowikiClass/play-circle.svg": "0999",
	"./videowikiClass/smile.svg": "d314",
	"./videowikiClass/trello.svg": "50bf",
	"./videowikiClass/users.svg": "f1f2",
	"./videowikiClass/video.svg": "161f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1de8";